const getDaysBetweenDates = (dateText1, dateText2) => {
  //millseconds in a day
  const DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24;

  //convert the date strings to actual dates
  const date1 = new Date(dateText1);
  const date2 = new Date(dateText2);

  // get the difference between the two days
  const diffTime = Math.abs(date2 - date1);

  // divide it by no of milliseconds in a single day
  const diffDays = Math.ceil(diffTime / DAY_IN_MILLISECONDS);

  //return the days
  return diffDays;
};

export default getDaysBetweenDates;
